import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';

const Row = styled.tr``;

const Cell = styled.td.attrs({
  colSpan: 10,
})`
  width: 100%;
`;

const Layout = styled.div`
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  min-height: ${toRem(400)};
  padding: ${toRem(theme.space.xl)};
`;

interface EmptyTableProps {
  children?: React.ReactNode;
}

const EmptyTable: React.FC<EmptyTableProps> = ({ children }) => (
  <Row>
    <Cell>
      <Layout>{children}</Layout>
    </Cell>
  </Row>
);

export default EmptyTable;
